module.exports = __webpack_public_path__ + "static/media/vaneyk-3.30ee5c36.jpeg";